"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataHooks = void 0;
var dataHooks = {
  datePickerCalendar: 'date-picker-calendar',
  datePickerPopover: 'date-picker-popover',
  datePickerInputContainer: 'date-picker-input-container',
  datePickerInput: 'date-picker-input'
};
exports.dataHooks = dataHooks;